import type { WorkflowStepConfig } from '@kfolks/types'

/**
 * Detects whether a step has shapes the visual canvas / properties panel
 * doesn't surface authoring widgets for. Today the only such case is a
 * non-trivial `after.guard` — the properties panel's outgoing-transition
 * editor only authors `after.on` + `after.next`, never `after.guard`.
 *
 * Per ADR-0012 the shipped contract has no parallel branches or
 * hierarchical states, so the advanced-fixture is "step with a
 * `transitionGuard`" — not a parallel state. Future `WorkflowStepConfig`
 * variants the builder hasn't been updated to support would also fall
 * into this bucket; the discriminator-default `: never` in the renderer
 * is the compile-time guard, this function is the runtime one.
 *
 * Per the workflow-builder capability spec: "advanced" steps render as
 * read-only nodes with an "Edit in Raw JSON" CTA, and round-trip
 * byte-equivalently on save. Admins author the guard via Raw JSON.
 */
export function isAdvancedStep(step: WorkflowStepConfig): boolean {
	return step.after?.guard !== undefined
}

/** Convenience for canvas/banner consumers. */
export function hasAnyAdvancedStep(steps: ReadonlyArray<WorkflowStepConfig>): boolean {
	return steps.some(isAdvancedStep)
}
